import React, { MouseEvent, useCallback, KeyboardEvent } from 'react';

interface Output {
  open: boolean;
  anchorEl: null | HTMLElement;
  toggle(event: { currentTarget: HTMLElement }): void;
  close(event?: { stopPropagation?: () => void }): void;
}

export function usePopover(onClose?: () => void, onOpen?: () => void): Output {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const toggle = useCallback(
    (event: { currentTarget: HTMLElement; stopPropagation?: () => {} }) => {
      event?.stopPropagation?.();
      setAnchorEl(event.currentTarget);
      if (event && onOpen) {
        onOpen();
      }
    },
    [onOpen]
  );

  const close = useCallback(
    (event: MouseEvent | KeyboardEvent) => {
      event?.stopPropagation?.();
      onClose?.();
      setAnchorEl(null);
    },
    [onClose]
  );

  return {
    anchorEl,
    open,
    toggle,
    close
  };
}
